import React from 'react'

import { SaveIcon, CancelIcon } from '../icons'

import FloatingButton from '../floatingButton'

const SaveButton = ({ canCancel, onCancel, ...props }) => (
  <FloatingButton {...props} additional={
    canCancel ? [{ name: 'reset', icon: <CancelIcon />, onClick: onCancel }] : []
  }>
    <SaveIcon />
  </FloatingButton>
)

export default SaveButton
